export enum FailureFactorType {
  Plus = '+',
  Minus = '-'
}
